import { logger } from '../core/services/loggerService';

const addHtmlAttribute = (
  htmlSelector: string,
  attribute: string,
  value: string,
): void => {
  const element = document.querySelector(htmlSelector);
  if (element) {
    element.setAttribute(attribute, value);
  }
};

const assertAncestorOverflowVisible = (): boolean => {
  let parent = document.querySelector('#flipdish-menu').parentElement;

  while (parent) {
    const hasOverflow = getComputedStyle(parent).overflow;
    if (hasOverflow !== 'visible') {
      parent.style.setProperty('overflow', 'visible', 'important');
    }
    parent = parent.parentElement;
  }

  return false;
};

const ensureVisible = (element: Element | null | Text) => {
  if (!element) {
    return;
  }

  const asElement = element as Element;
  const rect =
    asElement.getBoundingClientRect && asElement.getBoundingClientRect();
  if (!rect) {
    return;
  }
  const visible: boolean =
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth);

  if (visible) {
    return;
  }

  asElement.scrollIntoView();
};

const loadFont = (wlId: number, fontName: string = null): string => {
  const fdServiceFonts = [
    '', // default font setting
    'ABeeZee',
    'Aboreto',
    'Aclonica',
    'Actor',
    'Adamina',
    'AdobeBlank',
    'AdventPro',
    'AkayaKanadaka',
    'AkayaTelivigala',
    'Akronim',
    'AksaraBaliGalang',
    'Akshar',
    'Alata',
    'Alatsi',
    'AlbertSans',
    'Aldrich',
    'Alegreya',
    'AlegreyaSC',
    'AlegreyaSans',
    'AlegreyaSansSC',
    'Aleo',
    'AlexBrush',
    'AlfaSlabOne',
    'Alice',
    'Alike',
    'AlikeAngular',
    'Allison',
    'Allura',
    'AlumniSans',
    'AlumniSansCollegiateOne',
    'AlumniSansInlineOne',
    'AlumniSansPinstripe',
    'Amaranth',
    'AmaticSC',
    'Amethysta',
    'Amiko',
    'Amiri',
    'AmiriQuran',
    'AmiriQuranColored',
    'Amita',
    'Anaheim',
    'AndadaPro',
    'AnekBangla',
    'AnekDevanagari',
    'AnekGujarati',
    'AnekGurmukhi',
    'AnekKannada',
    'AnekLatin',
    'AnekMalayalam',
    'AnekOdia',
    'AnekTamil',
    'AnekTelugu',
    'Angkor',
    'AnonymousPro',
    'Anton',
    'Antonio',
    'Anybody',
    'AoboshiOne',
    'Archivo',
    'ArchivoBlack',
    'ArchivoNarrow',
    'AreYouSerious',
    'ArefRuqaa',
    'Arima',
    'ArimaMadurai',
    'Arimo',
    'Arizonia',
    'Arsenal',
    'Artifika',
    'Arvo',
    'Arya',
    'Asap',
    'AsapCondensed',
    'AsapVFBeta',
    'Asar',
    'Assistant',
    'Athiti',
    'AtkinsonHyperlegible',
    'Atma',
    'AtomicAge',
    'Aubrey',
    'Audiowide',
    'AutourOne',
    'AzeretMono',
    'B612',
    'B612Mono',
    'Babylonica',
    'BadScript',
    'Bahiana',
    'Bahianita',
    'BaiJamjuree',
    'BakbakOne',
    'Ballet',
    'Baloo2',
    'BalooBhai2',
    'BalooBhaijaan2',
    'BalooBhaina2',
    'BalooChettan2',
    'BalooDa2',
    'BalooPaaji2',
    'BalooTamma2',
    'BalooTammudu2',
    'BalooThambi2',
    'BalsamiqSans',
    'Bangers',
    'Barlow',
    'BarlowCondensed',
    'BarlowSemiCondensed',
    'Barriecito',
    'Barrio',
    'Basic',
    'Baskervville',
    'Battambang',
    'Baumans',
    'Bayon',
    'BeVietnam',
    'BeVietnamPro',
    'BeauRivage',
    'BebasNeue',
    'Bellefair',
    'Belleza',
    'Bellota',
    'BellotaText',
    'Benne',
    'BerkshireSwash',
    'Besley',
    'BethEllen',
    'Bevan',
    'Bhavuka',
    'BhuTukaExpandedOne',
    'BigShouldersDisplay',
    'BigShouldersInlineDisplay',
    'BigShouldersInlineText',
    'BigShouldersStencilDisplay',
    'BigShouldersStencilText',
    'BigShouldersText',
    'BigelowRules',
    'Bilbo',
    'BioRhyme',
    'BioRhymeExpanded',
    'Birthstone',
    'BirthstoneBounce',
    'Biryani',
    'Bitter',
    'BlackAndWhitePicture',
    'BlackHanSans',
    'BlackOpsOne',
    'Blaka',
    'BlakaHollow',
    'Blinker',
    'BodoniModa',
    'Bokor',
    'BonaNova',
    'Bonbon',
    'BonheurRoyale',
    'BowlbyOneSC',
    'Brawler',
    'BrunoAce',
    'BrunoAceSC',
    'Brygada1918',
    'Bungee',
    'BungeeColor',
    'BungeeHairline',
    'BungeeInline',
    'BungeeOutline',
    'BungeeShade',
    'ButterflyKids',
    'Cabin',
    'CabinCondensed',
    'CabinSketch',
    'CaesarDressing',
    'Cairo',
    'CairoPlay',
    'Caladea',
    'Calistoga',
    'Calligraffitti',
    'Cambay',
    'CantoraOne',
    'Caramel',
    'Carattere',
    'CarroisGothic',
    'CarroisGothicSC',
    'Castoro',
    'Catamaran',
    'Caveat',
    'ChakraPetch',
    'Changa',
    'Charm',
    'Charmonman',
    'Chathura',
    'ChelseaMarket',
    'Cherish',
    'CherryBombOne',
    'CherryCreamSoda',
    'Chewy',
    'Chilanka',
    'Chivo',
    'Chokokutai',
    'Chonburi',
    'Cinzel',
    'ClickerScript',
    'Codystar',
    'Comfortaa',
    'Comforter',
    'ComforterBrush',
    'ComicNeue',
    'ComingSoon',
    'Commissioner',
    'Corben',
    'Corinthia',
    'Cormorant',
    'CormorantGaramond',
    'CormorantInfant',
    'CormorantSC',
    'CormorantUnicase',
    'CormorantUpright',
    'CourierPrime',
    'Cousine',
    'CoveredByYourGrace',
    'CraftyGirls',
    'CrimsonPro',
    'CrimsonText',
    'Crushed',
    'Cuprum',
    'CuteFont',
    'CutiveMono',
    'DMMono',
    'DMSans',
    'DMSerifDisplay',
    'DMSerifText',
    'DancingScript',
    'Dangrek',
    'DarkerGrotesque',
    'DarumadropOne',
    'DavidLibre',
    'DelaGothicOne',
    'DenkOne',
    'Dhurjati',
    'DidactGothic',
    'DigitalNumbers',
    'DoHyeon',
    'Dokdo',
    'Domine',
    'DonegalOne',
    'Dongle',
    'Dosis',
    'DotGothic16',
    'DynaPuff',
    'Dynalight',
    'EBGaramond',
    'EagleLake',
    'EastSeaDokdo',
    'Eczar',
    'EduNSWACTFoundation',
    'EduQLDBeginner',
    'EduSABeginner',
    'EduTASBeginner',
    'EduVICWANTBeginner',
    'EkMukta',
    'ElMessiri',
    'Electrolize',
    'Elsie',
    'EmblemaOne',
    'EmilysCandy',
    'EncodeSans',
    'EncodeSansCondensed',
    'EncodeSansExpanded',
    'EncodeSansSC',
    'EncodeSansSemiCondensed',
    'EncodeSansSemiExpanded',
    'Engagement',
    'Englebert',
    'Enriqueta',
    'Ephesis',
    'Epilogue',
    'Estonia',
    'Exo',
    'Exo2',
    'ExpletusSans',
    'Explora',
    'Fahkwang',
    'FamiljenGrotesk',
    'Farro',
    'Farsan',
    'Fascinate',
    'FascinateInline',
    'FasterOne',
    'Fasthand',
    'Faustina',
    'Federant',
    'Federo',
    'Festive',
    'Figtree',
    'FingerPaint',
    'Finlandica',
    'FiraCode',
    'FiraSans',
    'FiraSansCondensed',
    'FiraSansExtraCondensed',
    'FjallaOne',
    'Flavors',
    'FleurDeLeah',
    'FlowBlock',
    'FlowCircular',
    'FlowRounded',
    'FontdinerSwanky',
    'Forum',
    'FrancoisOne',
    'FrankRuhlLibre',
    'Fraunces',
    'FreckleFace',
    'FrederickatheGreat',
    'Fredoka',
    'Freehand',
    'Frijole',
    'Fruktur',
    'Fuggles',
    'FuzzyBubbles',
    'Gabriela',
    'Gaegu',
    'Galada',
    'Galindo',
    'GamjaFlower',
    'Gayathri',
    'Gelasio',
    'GemunuLibre',
    'GenBasB',
    'GenBkBasR',
    'Genos',
    'Georama',
    'GideonRoman',
    'Gidugu',
    'Girassol',
    'GloriaHallelujah',
    'Glory',
    'Gluten',
    'Goldman',
    'Gorditas',
    'GothicA1',
    'Gotu',
    'GowunBatang',
    'GowunDodum',
    'GrandHotel',
    'Grandstander',
    'GrapeNuts',
    'GreatVibes',
    'GrechenFuemen',
    'Grenze',
    'GrenzeGotisch',
    'GreyQo',
    'Griffy',
    'Gruppo',
    'Gugi',
    'Gulzar',
    'Gupter',
    'Gwendolyn',
    'HachiMaruPop',
    'Hahmlet',
    'Hanalei',
    'HanaleiFill',
    'Handjet',
    'Hannari',
    'Hanuman',
    'HappyMonkey',
    'Heebo',
    'HennyPenny',
    'HeptaSlab',
    'HermeneusOne',
    'HiMelody',
    'HinaMincho',
    'Hind',
    'HindColombo',
    'HindGuntur',
    'HindJalandhar',
    'HindKochi',
    'HindMadurai',
    'HindMysuru',
    'HindSiliguri',
    'HindVadodara',
    'HomemadeApple',
    'Homenaje',
    'Hubballi',
    'Hurricane',
    'IBMPlexSansKR',
    'IMFELLDoublePica',
    'IMFeDPsc28P',
    'IMFeENit28P',
    'IMFeENsc28P',
    'IMFeFCrm28P',
    'IMFeFCsc28P',
    'IMFeGPrm28P',
    'IMFeGPsc28P',
    'IMFePIit28P',
    'IMFePIsc28P',
    'IbarraRealNova',
    'Iceberg',
    'Iceland',
    'Imbue',
    'ImperialScript',
    'Inconsolata',
    'IndieFlower',
    'IngridDarling',
    'InknutAntiqua',
    'InriaSans',
    'InriaSerif',
    'Inspiration',
    'Inter',
    'InterTight',
    'IrishGrover',
    'IslandMoments',
    'Italianno',
    'Itim',
    'JacquesFrancois',
    'JacquesFrancoisShadow',
    'Jaldi',
    'JejuGothic',
    'JejuHallasan',
    'JejuMyeongjo',
    'JetBrainsMono',
    'JimNightshade',
    'Joan',
    'JollyLodger',
    'Jomhuria',
    'Jomolhari',
    'JosefinSans',
    'JosefinSlab',
    'Jost',
    'Jua',
    'JuliusSansOne',
    'Junge',
    'Jura',
    'JustAnotherHand',
    'K2D',
    'Kadwa',
    'KaiseiDecol',
    'KaiseiHarunoUmi',
    'KaiseiOpti',
    'KaiseiTokumin',
    'Kalam',
    'Kanit',
    'Kantumruy',
    'KantumruyPro',
    'Kapakana',
    'Karantina',
    'Karla',
    'KarlaTamilUpright',
    'Katibeh',
    'KaushanScript',
    'Kavivanar',
    'KdamThmorPro',
    'Kenia',
    'Kings',
    'KirangHaerang',
    'KiwiMaru',
    'KleeOne',
    'KoHo',
    'Kodchasan',
    'KohSantepheap',
    'Kokoro',
    'KolkerBrush',
    'Kosugi',
    'KosugiMaru',
    'Koulen',
    'Kranky',
    'Kreon',
    'KronaOne',
    'Krub',
    'Kufam',
    'KulimPark',
    'KumarOne',
    'KumbhSans',
    'Kurale',
    'Lacquer',
    'Lalezar',
    'Lancelot',
    'Langar',
    'LaoMuangDon',
    'LaoMuangKhong',
    'LaoSansPro',
    'Lato',
    'LavishlyYours',
    'LeagueGothic',
    'LeagueSpartan',
    'Lemonada',
    'LemonadaVFBeta',
    'Lexend',
    'LexendDeca',
    'LexendExa',
    'LexendGiga',
    'LexendMega',
    'LexendPeta',
    'LexendTera',
    'LexendZetta',
    'LibreBarcode128',
    'LibreBarcode128Text',
    'LibreBarcode39',
    'LibreBarcode39Extended',
    'LibreBarcode39ExtendedText',
    'LibreBarcode39Text',
    'LibreBaskerville',
    'LibreBodoni',
    'LibreCaslonDisplay',
    'LibreCaslonText',
    'LibreFranklin',
    'Licorice',
    'LifeSavers',
    'Literata',
    'LiuJianMaoCao',
    'Livvic',
    'Lobster',
    'LobsterTwo',
    'LondrinaOutline',
    'LondrinaShadow',
    'LondrinaSketch',
    'LondrinaSolid',
    'LongCang',
    'Lora',
    'LoveLight',
    'LoversQuarrel',
    'LuckiestGuy',
    'LuxuriousRoman',
    'LuxuriousScript',
    'MPLUS1',
    'MPLUS1Code',
    'MPLUS1p',
    'MPLUS2',
    'MPLUSCodeLatin',
    'MaShanZheng',
    'Mada',
    'MaidenOrange',
    'Maitree',
    'MajorMonoDisplay',
    'Mali',
    'Mandali',
    'Manjari',
    'Manrope',
    'Mansalva',
    'Manuale',
    'Marcellus',
    'MarcellusSC',
    'Margarine',
    'MarkaziText',
    'Marmelad',
    'Martel',
    'MartelSans',
    'MavenPro',
    'MavenProVFBeta',
    'McLaren',
    'MeaCulpa',
    'Meddon',
    'MedievalSharp',
    'MeeraInimai',
    'MeowScript',
    'Merriweather',
    'MerriweatherSans',
    'MervaleScript',
    'Metal',
    'MetalMania',
    'Metrophobic',
    'Milonga',
    'Miltonian',
    'MiltonianTattoo',
    'Mina',
    'Mingzat',
    'Miniver',
    'MiriamLibre',
    'Mirza',
    'Mitr',
    'MochiyPopOne',
    'MochiyPopPOne',
    'Modak',
    'Mogra',
    'Mohave',
    'Molle',
    'Monda',
    'MonomaniacOne',
    'MontaguSlab',
    'MonteCarlo',
    'Montez',
    'Montserrat',
    'MontserratAlternates',
    'MooLahLah',
    'MoonDance',
    'Moul',
    'Moulpali',
    'MouseMemoirs',
    'MsMadi',
    'Mukta',
    'MuktaMahee',
    'MuktaMalar',
    'MuktaVaani',
    'Mulish',
    'Murecho',
    'MuseoModerno',
    'MySoul',
    'MyanmarSansPro',
    'MysteryQuest',
    'NATS',
    'NTR',
    'NanumBrushScript',
    'NanumGothic',
    'NanumGothicCoding',
    'NanumMyeongjo',
    'NanumPenScript',
    'Neonderthaw',
    'NerkoOne',
    'Neucha',
    'Neuton',
    'NewRocker',
    'NewTegomin',
    'NewsCycle',
    'Newsreader',
    'NicoMoji',
    'Nikukyu',
    'Niramit',
    'Nokora',
    'Notable',
    'NoticiaText',
    'NotoKufiArabic',
    'NotoMusic',
    'NotoNaskhArabic',
    'NotoNaskhArabicUI',
    'NotoNastaliqUrdu',
    'NotoRashiHebrew',
    'NotoSans',
    'NotoSansAdlam',
    'NotoSansAdlamUnjoined',
    'NotoSansAnatolianHieroglyphs',
    'NotoSansArabic',
    'NotoSansArabicUI',
    'NotoSansArmenian',
    'NotoSansAvestan',
    'NotoSansBalinese',
    'NotoSansBamum',
    'NotoSansBassaVah',
    'NotoSansBatak',
    'NotoSansBengali',
    'NotoSansBengaliUI',
    'NotoSansBhaiksuki',
    'NotoSansBrahmi',
    'NotoSansBuginese',
    'NotoSansBuhid',
    'NotoSansCanadianAboriginal',
    'NotoSansCarian',
    'NotoSansCaucasianAlbanian',
    'NotoSansChakma',
    'NotoSansCham',
    'NotoSansCherokee',
    'NotoSansCoptic',
    'NotoSansCuneiform',
    'NotoSansCypriot',
    'NotoSansDeseret',
    'NotoSansDevanagari',
    'NotoSansDevanagariUI',
    'NotoSansDisplay',
    'NotoSansDuployan',
    'NotoSansEgyptianHieroglyphs',
    'NotoSansElbasan',
    'NotoSansElymaic',
    'NotoSansEthiopic',
    'NotoSansGeorgian',
    'NotoSansGlagolitic',
    'NotoSansGothic',
    'NotoSansGrantha',
    'NotoSansGujarati',
    'NotoSansGujaratiUI',
    'NotoSansGunjalaGondi',
    'NotoSansGurmukhi',
    'NotoSansGurmukhiUI',
    'NotoSansHK',
    'NotoSansHanifiRohingya',
    'NotoSansHanunoo',
    'NotoSansHatran',
    'NotoSansHebrew',
    'NotoSansImperialAramaic',
    'NotoSansIndicSiyaqNumbers',
    'NotoSansInscriptionalPahlavi',
    'NotoSansInscriptionalParthian',
    'NotoSansJP',
    'NotoSansJavanese',
    'NotoSansKR',
    'NotoSansKaithi',
    'NotoSansKannada',
    'NotoSansKannadaUI',
    'NotoSansKayahLi',
    'NotoSansKharoshthi',
    'NotoSansKhmer',
    'NotoSansKhmerUI',
    'NotoSansKhojki',
    'NotoSansKhudawadi',
    'NotoSansLao',
    'NotoSansLaoUI',
    'NotoSansLepcha',
    'NotoSansLimbu',
    'NotoSansLinearA',
    'NotoSansLinearB',
    'NotoSansLisu',
    'NotoSansLycian',
    'NotoSansLydian',
    'NotoSansMahajani',
    'NotoSansMalayalam',
    'NotoSansMalayalamUI',
    'NotoSansMandaic',
    'NotoSansManichaean',
    'NotoSansMarchen',
    'NotoSansMasaramGondi',
    'NotoSansMath',
    'NotoSansMayanNumerals',
    'NotoSansMedefaidrin',
    'NotoSansMeeteiMayek',
    'NotoSansMendeKikakui',
    'NotoSansMeroitic',
    'NotoSansMiao',
    'NotoSansModi',
    'NotoSansMongolian',
    'NotoSansMono',
    'NotoSansMro',
    'NotoSansMultani',
    'NotoSansMyanmar',
    'NotoSansMyanmarUI',
    'NotoSansNKo',
    'NotoSansNabataean',
    'NotoSansNewTaiLue',
    'NotoSansNewa',
    'NotoSansNushu',
    'NotoSansOgham',
    'NotoSansOlChiki',
    'NotoSansOldHungarian',
    'NotoSansOldItalic',
    'NotoSansOldNorthArabian',
    'NotoSansOldPermic',
    'NotoSansOldPersian',
    'NotoSansOldSogdian',
    'NotoSansOldSouthArabian',
    'NotoSansOldTurkic',
    'NotoSansOriya',
    'NotoSansOriyaUI',
    'NotoSansOsage',
    'NotoSansOsmanya',
    'NotoSansPahawhHmong',
    'NotoSansPalmyrene',
    'NotoSansPauCinHau',
    'NotoSansPhagsPa',
    'NotoSansPhoenician',
    'NotoSansPsalterPahlavi',
    'NotoSansRejang',
    'NotoSansRunic',
    'NotoSansSC',
    'NotoSansSamaritan',
    'NotoSansSaurashtra',
    'NotoSansSharada',
    'NotoSansShavian',
    'NotoSansSiddham',
    'NotoSansSinhala',
    'NotoSansSinhalaUI',
    'NotoSansSogdian',
    'NotoSansSoraSompeng',
    'NotoSansSoyombo',
    'NotoSansSundanese',
    'NotoSansSylotiNagri',
    'NotoSansSymbols',
    'NotoSansSymbols2',
    'NotoSansSyriac',
    'NotoSansTC',
    'NotoSansTagalog',
    'NotoSansTagbanwa',
    'NotoSansTaiLe',
    'NotoSansTaiTham',
    'NotoSansTaiViet',
    'NotoSansTakri',
    'NotoSansTamil',
    'NotoSansTamilSupplement',
    'NotoSansTamilUI',
    'NotoSansTelugu',
    'NotoSansTeluguUI',
    'NotoSansThaana',
    'NotoSansThai',
    'NotoSansThaiLooped',
    'NotoSansThaiUI',
    'NotoSansTifinagh',
    'NotoSansTirhuta',
    'NotoSansUgaritic',
    'NotoSansVai',
    'NotoSansWancho',
    'NotoSansWarangCiti',
    'NotoSansYi',
    'NotoSansZanabazarSquare',
    'NotoSerif',
    'NotoSerifAhom',
    'NotoSerifArmenian',
    'NotoSerifBalinese',
    'NotoSerifBengali',
    'NotoSerifDevanagari',
    'NotoSerifDisplay',
    'NotoSerifDogra',
    'NotoSerifEthiopic',
    'NotoSerifGeorgian',
    'NotoSerifGrantha',
    'NotoSerifGujarati',
    'NotoSerifGurmukhi',
    'NotoSerifHK',
    'NotoSerifHebrew',
    'NotoSerifJP',
    'NotoSerifKR',
    'NotoSerifKannada',
    'NotoSerifKhmer',
    'NotoSerifLao',
    'NotoSerifMalayalam',
    'NotoSerifMyanmar',
    'NotoSerifNyiakengPuachueHmong',
    'NotoSerifOriya',
    'NotoSerifSC',
    'NotoSerifSinhala',
    'NotoSerifTC',
    'NotoSerifTamil',
    'NotoSerifTangut',
    'NotoSerifTelugu',
    'NotoSerifThai',
    'NotoSerifTibetan',
    'NotoSerifYezidi',
    'NotoTraditionalNushu',
    'Nunito',
    'NunitoSans',
    'NuosuSIL',
    'OdibeeSans',
    'OdorMeanChey',
    'Oi',
    'OldStandard',
    'Ole',
    'OoohBaby',
    'OpenSans',
    'Oranienbaum',
    'Orbitron',
    'Oregano',
    'OrelegaOne',
    'Orienta',
    'OriginalSurfer',
    'Oswald',
    'OtomanopeeOne',
    'Outfit',
    'Overpass',
    'OverpassMono',
    'Oxanium',
    'PTM55FT',
    'Pacifico',
    'Padauk',
    'Palanquin',
    'PalanquinDark',
    'PaletteMosaic',
    'Pangolin',
    'Paprika',
    'Parisienne',
    'PassionsConflict',
    'PatrickHandSC',
    'Pattaya',
    'Pavanam',
    'PaytoneOne',
    'Peralta',
    'PermanentMarker',
    'Petemoss',
    'PetitFormalScript',
    'Petrona',
    'Philosopher',
    'Piazzolla',
    'PinyonScript',
    'Play',
    'Playball',
    'PlayfairDisplay',
    'PlayfairDisplaySC',
    'PlusJakartaSans',
    'Podkova',
    'PodkovaVFBeta',
    'PoetsenOne',
    'PoiretOne',
    'PoorStory',
    'Poppins',
    'PorterSansBlock',
    'PottaOne',
    'PragatiNarrow',
    'Praise',
    'Prata',
    'Preahvihear',
    'PressStart2P',
    'Pridi',
    'PrincessSofia',
    'Prompt',
    'ProstoOne',
    'ProzaLibre',
    'PublicSans',
    'PuppiesPlay',
    'PurplePurse',
    'Pushster',
    'Quattrocento',
    'QuattrocentoSans',
    'Questrial',
    'Quicksand',
    'Quintessential',
    'Qwigley',
    'QwitcherGrypen',
    'RUSerius',
    'RacingSansOne',
    'RadioCanada',
    'Radley',
    'Rakkas',
    'Raleway',
    'RalewayDots',
    'RampartOne',
    'Ranchers',
    'Rancho',
    'Rasa',
    'Rationale',
    'ReadexPro',
    'Recursive',
    'RedHatDisplay',
    'RedHatMono',
    'RedHatText',
    'RedRose',
    'Redacted',
    'RedactedScript',
    'Redressed',
    'ReemKufi',
    'ReemKufiFun',
    'ReenieBeanie',
    'ReggaeOne',
    'RhodiumLibre',
    'Ribeye',
    'Righteous',
    'Risque',
    'RoadRage',
    'Roboto',
    'RobotoFlex',
    'RobotoMono',
    'RobotoSerif',
    'RobotoSlab',
    'Rock3D',
    'RockSalt',
    'RocknRollOne',
    'Rokkitt',
    'RokkittVFBeta',
    'Romanesco',
    'RopaSans',
    'Rosario',
    'RoundedMplus1c',
    'Rowdies',
    'Rubik',
    'RubikBeastly',
    'RubikBubbles',
    'RubikBurned',
    'RubikDirt',
    'RubikDistressed',
    'RubikGlitch',
    'RubikIso',
    'RubikMarkerHatch',
    'RubikMaze',
    'RubikMicrobe',
    'RubikMonoOne',
    'RubikMoonrocks',
    'RubikPuddles',
    'RubikWetPaint',
    'Ruda',
    'RugeBoogie',
    'RumRaisin',
    'Ruthie',
    'STIXTwoMath',
    'STIXTwoText',
    'Sacramento',
    'Sahitya',
    'Saira',
    'SairaCondensed',
    'SairaExtraCondensed',
    'SairaSemiCondensed',
    'SairaStencilOne',
    'Sansation',
    'Sansita',
    'SansitaOne',
    'SansitaSwashed',
    'Sarabun',
    'Sarala',
    'SassyFrass',
    'Satisfy',
    'SawarabiGothic',
    'SawarabiMincho',
    'Scada',
    'Schoolbell',
    'ScopeOne',
    'SeaweedScript',
    'SecularOne',
    'SedgwickAve',
    'SedgwickAveDisplay',
    'Sen',
    'SendFlowers',
    'SeoulNamsanVertical',
    'Sevillana',
    'ShadowsIntoLightTwo',
    'Shalimar',
    'Share',
    'ShareTech',
    'ShareTechMono',
    'ShipporiAntique',
    'ShipporiAntiqueB1',
    'ShipporiMincho',
    'ShipporiMinchoB1',
    'Shizuru',
    'Shojumaru',
    'Shrikhand',
    'SigmarOne',
    'Signika',
    'SignikaNegative',
    'SignikaNegativeSC',
    'SignikaSC',
    'Silkscreen',
    'Simonetta',
    'SingleDay',
    'SirinStencil',
    'Sitara',
    'Skranji',
    'Slabo13px',
    'Slabo27px',
    'Slackey',
    'SlacksideOne',
    'Smooch',
    'SmoochSans',
    'Sniglet',
    'SofadiOne',
    'SofiaSans',
    'Solway',
    'SometypeMono',
    'SongMyung',
    'Sono',
    'SonsieOne',
    'Sora',
    'Souliyo',
    'SourceCodePro',
    'SourceSansPro',
    'SourceSerif4',
    'SourceSerifPro',
    'SpaceGrotesk',
    'SpaceMono',
    'Spartan',
    'SpecialElite',
    'Spectral',
    'SpectralSC',
    'SpicyRice',
    'Splash',
    'SplineSans',
    'SplineSansMono',
    'SquarePeg',
    'Sriracha',
    'Srisakdi',
    'Staatliches',
    'Stalemate',
    'StalinistOne',
    'StardosStencil',
    'Stick',
    'StickNoBills',
    'StintUltraCondensed',
    'StintUltraExpanded',
    'Strong',
    'StyleScript',
    'Stylish',
    'SueEllenFrancisco',
    'SuezOne',
    'SulphurPoint',
    'Sumana',
    'Sunshiney',
    'Sura',
    'Suwannaphum',
    'Syncopate',
    'Syne',
    'SyneMono',
    'SyneTactile',
    'Tajawal',
    'Tangerine',
    'Tapestry',
    'Taprom',
    'Tauri',
    'Taviraj',
    'Telex',
    'TenaliRamakrishna',
    'TenorSans',
    'Texturina',
    'Thasadith',
    'TheNautigal',
    'Tillana',
    'Tinos',
    'TiroBangla',
    'TiroDevanagariHindi',
    'TiroDevanagariMarathi',
    'TiroDevanagariSanskrit',
    'TiroGurmukhi',
    'TiroKannada',
    'TiroTamil',
    'TiroTelugu',
    'Tomorrow',
    'Tourney',
    'TradeWinds',
    'TrainOne',
    'Trirong',
    'Trispace',
    'Trocchi',
    'Truculenta',
    'TsukimiRounded',
    'Tuffy',
    'TurretRoad',
    'TwinkleStar',
    'Ubuntu',
    'UbuntuCondensed',
    'UbuntuMono',
    'Uchen',
    'UncialAntiqua',
    'Underdog',
    'Unkempt',
    'Unna',
    'Updock',
    'Urbanist',
    'VT323',
    'VampiroOne',
    'VarelaRound',
    'Varta',
    'Vazirmatn',
    'VesperLibre',
    'ViaodaLibre',
    'Vibes',
    'Vidaloka',
    'Voces',
    'Volkhov',
    'Vollkorn',
    'VollkornSC',
    'VujahdayScript',
    'WaitingfortheSunrise',
    'WalterTurncoat',
    'Warnes',
    'WaterBrush',
    'Waterfall',
    'Whisper',
    'WindSong',
    'WireOne',
    'WorkSans',
    'XanhMono',
    'Yaldevi',
    'YanoneKaffeesatz',
    'Yantramanav',
    'YatraOne',
    'YeonSung',
    'YesevaOne',
    'Yesteryear',
    'Yomogi',
    'Yrsa',
    'YujiBoku',
    'YujiHentaiganaAkari',
    'YujiHentaiganaAkebono',
    'YujiMai',
    'YujiSyuku',
    'YuseiMagic',
    'ZCOOLKuaiLe',
    'ZCOOLQingKeHuangYou',
    'ZCOOLXiaoWei',
    'ZenAntique',
    'ZenAntiqueSoft',
    'ZenDots',
    'ZenKakuGothicAntique',
    'ZenKakuGothicNew',
    'ZenKurenaido',
    'ZenLoop',
    'ZenMaruGothic',
    'ZenOldMincho',
    'ZenTokyoZoo',
    'ZhiMangXing',
    'ZillaSlab',
    'ZillaSlabHighlight',
  ];

  const loadFontName = (fontName || 'Poppins').replace(/\s/g, '');

  if (!fdServiceFonts.includes(loadFontName)) {
    /**
     * If we do not have font in fonts.flpdish.com
     * its probably set in host website, in that case
     * we need to just set font amily with the font name
     * and initiate MUI theme with given font name
     * Please mind font name should be exactly what is received.
     * Even including the space.
     */
    logger.info(`Unknown Font ${fontName}`, {
      whiteLabelId: wlId,
    });

    const fontLink = document.createElement('style');
    fontLink.textContent = `
      @font-face {
        font-family: '${fontName}';
        font-style: normal;
      }
    `;
    document.head.appendChild(fontLink);
    return fontName;
  }

  const fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = `https://fonts.flipdish.com/${loadFontName}.css`;
  document.head.appendChild(fontLink);

  return loadFontName;
};

const skipToContent = (): void => {
  const firstEl = document.querySelector('#skip-to-content');
  if (firstEl) {
    ensureVisible(firstEl);
  }
};

export const domUtils = {
  addHtmlAttribute,
  assertAncestorOverflowVisible,
  ensureVisible,
  loadFont,
  skipToContent,
};
